import {useEffect} from "react";
import {openManagedSSE} from "@modules/realtime/sseClient.js";

export function useSSE(topic, handlers = {})
{
	useEffect(() =>
	{
		if (!topic) return;

		const API = import.meta.env.VITE_API_URL || "";
		const url = `${API}/api/events?topic=${encodeURIComponent(topic)}`;

		// Connessione SSE resiliente: su 401 (access scaduto) rinnova e riconnette,
		// invece del retry cieco di EventSource che andrebbe in loop di disconnessioni.
		return openManagedSSE(url, {listeners: handlers});
	}, [topic, JSON.stringify(Object.keys(handlers))]);
}
